import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpService } from '../../core';
import { Observable } from 'rxjs';
import { SmBaseService } from '../../core';
import { map } from 'rxjs/operators';

@Injectable()
export class AutomaticImportService extends SmBaseService {
    constructor(http: HttpService) {
        super(http, 'automaticImport');
    }

    get(): Observable<AutomaticImportModel> {
        return this._get().pipe(map((res: Response) => {
            return res.json() as AutomaticImportModel;
        }));
    }

    set(model: AutomaticImportModel) {
        return this._post('', model);
    }

    delete(id: number) {
        return this._delete(id);
    }
}

export class AutomaticImportModel {
    id: number;
    url: string;
    importTemplateId: number;
    settings: AutomaticImportSettings = new AutomaticImportSettings();
}

export class AutomaticImportSettings {
    fullImport: boolean;
    fullSync: boolean;
    lightImport: boolean;
    lightImportWithOfferUpdate: boolean;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/automatic-import.service.ts